// noinspection DuplicatedCode

import { PaymentOptionStatuses, useCurrencies } from 'mmfintech-backend-api'
import type { AccountBalanceResponse, PaymentOptionResponse } from 'mmfintech-backend-api/types'
import { checkSingleValue, formatFloat, isValidFunction, isValidString, tr } from 'mmfintech-commons'
import type React from 'react'
import './InputAmount.scss'

interface Props {
  label?: string
  amount?: string
  account?: AccountBalanceResponse
  setAmount?: (value: string) => void
  paymentOption?: PaymentOptionResponse
  error?: string
  setAmountError?: (error: string | null) => void
  placeholder?: string
  dataTest?: string
  [key: string]: any
}

function InputAmount({
  label,
  amount,
  account,
  setAmount,
  paymentOption,
  error,
  setAmountError,
  placeholder,
  dataTest,
  ...rest
}: Props) {
  const { currencyCode } = account || {}

  const { getCurrencyPrecision } = useCurrencies()
  const decimals = getCurrencyPrecision(currencyCode)

  function getLimits() {
    const { status, minAmount, maxAmount } = paymentOption || {}

    if (status === PaymentOptionStatuses.AVAILABLE) {
      const res = []

      if (minAmount > 0) {
        res.push(
          tr('PORTAL.COMPONENTS.INPUT_AMOUNT.MIN', 'Min: {{AMOUNT}}', { AMOUNT: formatFloat(minAmount, decimals) })
        )
      }
      if (maxAmount > 0) {
        res.push(
          tr('PORTAL.COMPONENTS.INPUT_AMOUNT.MAX', 'Max: {{AMOUNT}}', { AMOUNT: formatFloat(maxAmount, decimals) })
        )
      }

      return res.length > 0 && res.join(', ')
    }

    return null
  }

  function handleAmountChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (isValidFunction(setAmount)) {
      const val = checkSingleValue(e.target.value, { validation: 'float', decimals })
      setAmount(val)
      isValidFunction(setAmountError) && setAmountError(null)
    }
  }
  return (
    <div className='input-amount' {...rest}>
      <label className='input-amount__label'>{label}</label>

      {isValidFunction(setAmount) ? (
        <input
          className='input-amount__element'
          type='text'
          value={amount || ''}
          onChange={handleAmountChange}
          placeholder={placeholder || '0'}
          maxLength={16}
          data-test={dataTest}
        />
      ) : (
        <div className='input-amount__static' data-test={dataTest}>
          {amount || 0}
        </div>
      )}

      {isValidString(error) && <div className='input-amount__error'>{error}</div>}
      <div className='input-amount__limits'>{getLimits() || ' '}</div>
    </div>
  )
}

export default InputAmount
